function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M21.38 21.748c-3.676 3.003-15.159 3.003-18.76 0-3.678-3.002-3.303-15.837 0-19.215 3.301-3.377 15.459-3.377 18.76 0 3.303 3.378 3.678 16.213 0 19.215z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.415 16.161c-3.39 2.569-7.167 3.89-10.711 3.963C-.916 15.868-.376 5.52 2.706 2.512 5.48-.204 14.186-.718 19.196.97c1.232 4.843-1.31 11.007-6.781 15.19z",
  fill: "#FFF",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M16.875 12.095c.443.26.95.402 1.471.402.34 0 .669-.07.98-.182v5.152c0 .55-.439.995-.98.995h-.98v-4.97h-2.943v4.97H6.577a.988.988 0 01-.98-.995v-5.164c.803.282 1.715.226 2.451-.208a2.97 2.97 0 002.942 0c.886.52 2.056.52 2.943 0a2.97 2.97 0 002.942 0zm-5.394 1.396H7.558v2.982h3.923v-2.982zm5.884-7.953c.157 0 .304.08.402.21l2.452 3.479.089.268c.01 1.103-.873 2.008-1.962 2.008a1.936 1.936 0 01-1.471-.676 1.936 1.936 0 01-2.942 0 1.936 1.936 0 01-2.943 0 1.932 1.932 0 01-1.47.676c-.59 0-1.109-.259-1.472-.676a1.936 1.936 0 01-1.471.676c-1.089 0-1.971-.905-1.962-2.008l.089-.268 2.452-3.48a.51.51 0 01.402-.209z"
}));

function SvgSellerIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _ref);
}

export default SvgSellerIcon;